import { render, staticRenderFns } from "./upgrade_rule_ios.vue?vue&type=template&id=4b6ca2f4&scoped=true"
import script from "./upgrade_rule_ios.vue?vue&type=script&lang=js"
export * from "./upgrade_rule_ios.vue?vue&type=script&lang=js"
import style0 from "./upgrade_rule_ios.vue?vue&type=style&index=0&id=4b6ca2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ca2f4",
  null
  
)

export default component.exports